import React, { useState, useEffect } from 'react';
import { Field, ErrorMessage } from 'formik';
import { SampleService } from '../../Services/Sample.service';
import { RequestorService } from '../../Services/Requestor.Service';

const Autocomplete = ({  
  name,
  label,
  placeholder, 
  error,
  touched,
  value,
  setFieldValue,
  allowInputChange,
  disableInputChange,
  setDisableInputChange,
  selectedDonorIds,
  excludedDonorIds,
  sampleIds,
  isMatched,
  isRequestDuplicate,
  activeField,
  setActiveField,

  is_partof_parent_study,
  exclude_parent_study_donors,
  parent_study_id
}) => {

  const [exist, setExist] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [show, setShow] = useState(false);
  const [duplicateRequest, setDuplicateRequest] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [disableTyping, setDisableTyping] = useState(false);

  // const [parentStudyDonorIds, setParentStudyDonorIds] = useState([]);
  // // Load donors from parent study if needed
  // useEffect(() => {
  //   const fetchParentStudyDonors = async () => {debugger
  //     if (
  //       is_partof_parent_study === 'Yes' &&
  //       exclude_parent_study_donors === 'Yes' &&
  //       parent_study_id
  //     ) {
  //       try {
  //         const response = await RequestorService.fetchParentStudyDonors({ parent_study_id });  
  //         const donors = response.data || [];
  //         const donorIds = donors.map(d => d.donor_id);  
  //         setParentStudyDonorIds(donorIds);
  //       } catch (err) {
  //         console.error('Error fetching parent study donors', err);
  //         setParentStudyDonorIds([]);
  //       }
  //     } else {
  //       setParentStudyDonorIds([]);
  //     }
  //   };
  //   fetchParentStudyDonors();
  // }, [is_partof_parent_study, exclude_parent_study_donors, parent_study_id]);


  useEffect(() => {
    if(typeof isRequestDuplicate !== 'undefined' || isRequestDuplicate) {
      setDuplicateRequest(true);
    }
  }, [isRequestDuplicate]);
    
  useEffect(() => {
    if(!value) {
      setExist(false);
      setDisableTyping(false);
    }
  }, [value, exist, disableTyping]);

  useEffect(() => {
    
    if (activeField !== name && name != 'project_name') {
      setFieldValue(name, ''); 
      setFiltered([]); 
      setShow(false);  
    }

  }, [activeField]);

  const handleSuggestionClick = (value) => {    
    setFieldValue(name, value);
    setFiltered([]);
    setShow(false);        
    setExist(true);    

    if(allowInputChange == false){
      setDisableTyping(true);
      setDisableInputChange(true);
    }
  };

  const handleInputChange = (e) => {
    if (disableTyping && e.nativeEvent.inputType !== "deleteContentBackward") return;
    setFieldValue(name, e.target.value);
    setShow(false);
    setDuplicateRequest(false);
    setActiveField(name);
  };

  const handleKeyDown = (e) => {
    if (disableTyping && e.key !== 'Backspace') return;

    if (e.key === 'Enter') {
      setFiltered([]);
      setShow(false);
    } else if (e.key === 'ArrowUp') {
      if (activeIndex > 0) setActiveIndex(activeIndex - 1);
    } else if (e.key === 'ArrowDown') {
      if (activeIndex < filtered.length - 1) setActiveIndex(activeIndex + 1);
    } else if (e.key === 'Backspace') {
      setExist(false);

      if(allowInputChange == false){
        setDisableTyping(false);
      }
    }
  };

  const fetchData = async () => {
    try {      
      let params = { search: value || '' };    
      if (name === 'preferred_donor' || name === 'alternate_donor' || name === 'excluded_donor') {
        params.selected_donor_id = selectedDonorIds || [];
        params.sample_id = typeof sampleIds != 'undefined' && Object.keys(sampleIds).length > 0 ? Object.keys(sampleIds) : sampleIds != '' ? sampleIds : [];
        params.is_matched = isMatched || false;

        // Add only if they exist
        if (typeof is_partof_parent_study !== 'undefined' && is_partof_parent_study !== '') {
          params.is_partof_parent_study = is_partof_parent_study;
        }
        if (typeof parent_study_id !== 'undefined' && parent_study_id !== '') {
          params.parent_study_id = parent_study_id;
        }
        if (typeof exclude_parent_study_donors !== 'undefined' && exclude_parent_study_donors !== '') {
          params.exclude_parent_study_donors = exclude_parent_study_donors;
        }

      }      

      if(typeof excludedDonorIds != 'undefined' && excludedDonorIds != null && name === 'excluded_donor') {
        const combinedDonorIds = [...new Set([...selectedDonorIds, ...excludedDonorIds])];
        params.selected_donor_id = combinedDonorIds || [];
      }
      
      if(value) {
        const results = await SampleService.fetchAutoPopulateData(name, params);      
        setFiltered(results || []);

        if (results.length > 0 && (!exist || !value)) {
          if(duplicateRequest == true) { 
            setShow(false);
          } else {
            setShow(true);  
          }
        }
      }
      
    } catch (error) {
      setFiltered([]);
      setShow(false);
      console.error("Error while fetching", error);
    }
  };

  useEffect(() => {   
    if (!disableTyping) {
      const debounceTimeout = setTimeout(fetchData, 300);
      return () => clearTimeout(debounceTimeout);
    }    
  }, [value, disableTyping]); 

  return (
    <div className="autocomplete-container">
      <label htmlFor={name} className="form-label">
        {label}      <span className="text-red">*</span>
      </label>

      <div className="input-wrapper">
        <i className="search-icon el-icon-people"></i>
        <Field
          type="text"
          name={name}
          className="autocomplete-input form-control"
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          onChange={handleInputChange}
          value={value || ''} // Ensure each field has its own value
          data-error={error ? "true" : "false"}  
          autoComplete="off"
        />
      </div>

      {filtered && show && value && (
        <div className="autocomplete-dropdown">
          {filtered.length > 0 &&
            filtered.map((suggestion, index) => (
              <div
                key={`${name}-${index}`}  
                className={`autocomplete-item ${index === activeIndex ? 'active' : ''}`}
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion}
              </div>
            ))}
        </div>
      )}
  <div className="error-placeholder">
      {name == 'project_name' && error && touched && (
        <div className="text-danger">{error}</div>
      )}

      {name != 'project_name' && error && (
        <div className="text-danger ">{error}</div>
      )}
    </div></div>
  );
};

export default Autocomplete;
